import { ref } from 'vue';

const page = 'setup-events';

export default [
    {
        path: '/setup/' + page,
        name: `${page}-main`,
        exact: true,
        component: () => import('@/pages/setup/events/Index'),
        meta: {
            auth: true,
            permission: ['event.access'], // todo permissions
            title: 'Events',
            prefix: `${page}-main`
        },
        children: [
            {
                path: `/setup/events/event-templates`,
                name: `${page}-event-templates`,
                exact: true,
                component: () => import('@/pages/setup/events/event_templates/EventTemplatesMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-templates.access'],
                    title: 'Templates',
                    prefix: `${page}-event-templates`,
                },
            },
            {
                path: `/setup/events/event-types-configuration`,
                name: `${page}-event-types-configuration`,
                exact: true,
                component: () => import('@/pages/setup/events/event_type_configuration/EventTypeConfigurationMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-type-config.access'],
                    title: 'Event Types Configuration',
                    prefix: `${page}-types-configuration`,
                },
            },
            {
                path: `/setup/events/event-configuration-template-map`,
                name: `${page}-event-configuration-template-map`,
                exact: true,
                component: () => import('@/pages/setup/events/event_configuration_template_map/EventConfigurationTemplateMapMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-config-template-map.access'],
                    title: 'Event Configuration Template Map',
                    prefix: `${page}-event-configuration-template-map`,
                },
            }
        ]
    },

];
